export const BUYER_CITY = 'BUYER_CITY'
export const BUYER_GOALS = 'BUYER_GOALS'
export const BUYER_CLOSE_DATE = 'BUYER_CLOSE_DATE'
export const BUYER_MATTERS_MOST = 'BUYER_MATTERS_MOST'
export const BUYER_ONBOARDED = 'BUYER_ONBOARDED'

export const STEPS = {
  BUYER_CITY,
  BUYER_GOALS,
  BUYER_CLOSE_DATE,
  BUYER_MATTERS_MOST,
  BUYER_ONBOARDED
}

export const ORDERED_STEPS = [
  BUYER_CITY,
  BUYER_GOALS,
  BUYER_CLOSE_DATE,
  BUYER_MATTERS_MOST,
  BUYER_ONBOARDED
]

const GOAL_FIRST_HOME = 'purchase_first_home'
const GOAL_NEW_HOME = 'buy_different_home'
const GOAL_INVEST = 'invest_in_real_estate'
const GOAL_EXPLORE = 'explore_for_now'
const GOAL_SELL_CURRENT = 'sell_current'

export const GOALS = {
  GOAL_FIRST_HOME,
  GOAL_NEW_HOME,
  GOAL_INVEST,
  GOAL_EXPLORE,
  GOAL_SELL_CURRENT
}

export const ORDERED_NON_HOMEOWNER_GOALS = [
  GOAL_FIRST_HOME,
  GOAL_NEW_HOME,
  GOAL_INVEST,
  GOAL_EXPLORE
]

export const ORDERED_HOMEOWNER_GOALS = [
  GOAL_NEW_HOME,
  GOAL_SELL_CURRENT,
  GOAL_INVEST,
  GOAL_EXPLORE
]

const PRIORITY_SQFT = 'maximum_sqft'
const PRIORITY_RENTAL = 'airbnb_potential'
const PRIORITY_TIMING = 'right_timing'
const PRIORITY_BUDGET = 'budget'
const PRIORITY_DOWNPAYMENT = 'minimal_money_down'
const PRIORITY_NEIGHBORHOOD = 'desirable_neighborhood'
const PRIORITY_INVESTMENT = 'return_on_investment'
const PRIORITY_PARKS = 'outdoor_space'

export const PRIORITIES = {
  PRIORITY_SQFT,
  PRIORITY_RENTAL,
  PRIORITY_TIMING,
  PRIORITY_BUDGET,
  PRIORITY_DOWNPAYMENT,
  PRIORITY_NEIGHBORHOOD,
  PRIORITY_INVESTMENT,
  PRIORITY_PARKS
}

export const ORDERED_PRIORITIES = [
  PRIORITY_SQFT,
  PRIORITY_RENTAL,
  PRIORITY_TIMING,
  PRIORITY_BUDGET,
  PRIORITY_DOWNPAYMENT,
  PRIORITY_NEIGHBORHOOD,
  PRIORITY_INVESTMENT,
  PRIORITY_PARKS
]

export const REQUIRED_PRIORITY_COUNT = 3

export const QUESTION_CITY = 'buyer_city'
export const QUESTION_GOALS = 'buyer_goals'
export const QUESTION_DATE = 'buyer_close_date'
export const QUESTION_PRIORITIES = 'buyer_matters_most'

export const QUESTIONS = [
  QUESTION_CITY,
  QUESTION_GOALS,
  QUESTION_DATE,
  QUESTION_PRIORITIES
]

export const ORDERED_QUESTIONS = [
  QUESTION_CITY,
  QUESTION_GOALS,
  QUESTION_DATE,
  QUESTION_PRIORITIES
]

export const QUESTIONS_TO_STATE = {
  [QUESTION_CITY]: BUYER_CITY,
  [QUESTION_GOALS]: BUYER_GOALS,
  [QUESTION_DATE]: BUYER_CLOSE_DATE,
  [QUESTION_PRIORITIES]: BUYER_MATTERS_MOST
}
